import { useState } from "react";
import { Loader2, MailCheck } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { AuthShell, inputCls, btnCls } from "@/components/AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(data.message);
    } catch (err) {
      setError(err.response?.status === 422 ? "Please enter a valid email address." : formatApiErrorDetail(err.response?.data?.detail) || "Could not send the email. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Forgot password" subtitle="For restaurant owners. Staff, please ask your owner to set a new password.">
      {sent ? (
        <div data-testid="forgot-password-sent" className="flex gap-3 bg-emerald-950/40 border border-emerald-900/50 rounded-xl p-4 text-sm text-emerald-300">
          <MailCheck className="h-5 w-5 shrink-0" />
          <p>{sent} The link expires in 30 minutes. Check your spam folder if you can't see it.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-xs font-medium uppercase tracking-wider text-slate-400">Email</label>
            <input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} placeholder="you@restaurant.com" />
          </div>
          {error && <p data-testid="forgot-error" className="text-sm text-red-400 bg-red-950/40 border border-red-900/50 rounded-lg px-3 py-2">{error}</p>}
          <button data-testid="forgot-submit-button" type="submit" disabled={loading} className={btnCls}>
            {loading && <Loader2 className="h-4 w-4 animate-spin" />} Email me a reset link
          </button>
        </form>
      )}
    </AuthShell>
  );
}
